import { useCallback } from "react";
import useFeature from "hooks/useFeature";
import useRightSidebar from "hooks/useRightSidebar";
import SidebarInvestigationDetails from "security-app/components/Investigations/Details/SidebarInvestigationDetails";
import { useInvestigationDrawer } from "../contexts";
function useInvestigationPanel() {
  const isRightSidebarEnabled = useFeature("investigation_right_sidebar");
  const { openSidebar, closeSidebar } = useRightSidebar();
  const { selectedInvestigationId, setSelectedInvestigationId, setShowDrawer, setCollapsed, clearInvestigation } = useInvestigationDrawer();
  const openInvestigation = useCallback(
    (id) => {
      if (isRightSidebarEnabled) {
        openSidebar(SidebarInvestigationDetails(id));
      } else {
        setSelectedInvestigationId(id);
        setShowDrawer(true);
        setCollapsed(false);
      }
    },
    [isRightSidebarEnabled, openSidebar, setSelectedInvestigationId, setShowDrawer, setCollapsed]
  );
  const closeInvestigation = useCallback(() => {
    if (isRightSidebarEnabled) {
      clearInvestigation();
      closeSidebar();
    } else {
      setShowDrawer(false);
      setCollapsed(false);
    }
  }, [isRightSidebarEnabled, clearInvestigation, closeSidebar, setShowDrawer, setCollapsed]);
  const expandPanel = useCallback(() => {
    if (!isRightSidebarEnabled) {
      setCollapsed(false);
    }
  }, [isRightSidebarEnabled, setCollapsed]);
  const _setSelectedInvestigationId = (id, openInDrawer = false) => {
    setSelectedInvestigationId(id);
    if (openInDrawer) {
      openInvestigation(id);
    }
  };
  return {
    selectedInvestigationId,
    setSelectedInvestigationId: _setSelectedInvestigationId,
    openInvestigation,
    closeInvestigation,
    expandPanel
  };
}
export default useInvestigationPanel;
